export type GradientType = "linear" | "radial" | "conic";
export interface Stop { value: string; pos: number }

/** Builds the CSS gradient. Stops are sorted by position; positions are clamped to 0-100. */
export function gradientCss(type: GradientType, angle: number, stops: Stop[]): string {
  const list = [...stops]
    .map(s => ({ ...s, pos: Math.min(100, Math.max(0, Math.round(s.pos))) }))
    .sort((a, b) => a.pos - b.pos)
    .map(s => `${s.value} ${s.pos}%`)
    .join(", ");
  if (type === "radial") return `radial-gradient(circle at center, ${list})`;
  if (type === "conic") return `conic-gradient(from ${angle}deg at 50% 50%, ${list})`;
  return `linear-gradient(${angle}deg, ${list})`;
}

/** Evenly spaced default positions for n stops. */
export const evenPositions = (n: number): number[] => Array.from({ length: n }, (_, i) => (n === 1 ? 0 : Math.round((i * 100) / (n - 1))));
